import React from 'react'

export default function Row({className, children, vAlign="center"}) {
  return (
    <div className={`flex justify-between items-${vAlign} ${className ? className : ''}`}>
      {children}
    </div>
  );
}
